import * as React from "react";

import { Confirm, Delivery, Info, Payment, Accounting } from "./Chapters";

export default ({ key, method, kind, isMember, addressProposals }) => {
  switch (key) {
    case "INFO":
      return <Info {...{ method, addressProposals }} />;
    case "DELIVERY":
      return <Delivery {...{ method }} />;
    case "PAYMENT":
      return <Payment {...{ method, kind, isMember }} />;
    case "ACCOUNTING":
      return <Accounting {...{ method }} />;
    default:
      return <Confirm {...{ method }} />;
  }
};
